@if ((visible && !isMobileView) || (visible && isTablet) || (visible && isDesktop)) {
  <div class="modal_customer">
    <div class="modal_customer_body">
      <br>
        <div class="col-md-6">
          <div class="modal_customer_close" (click)="confirm()">
            Close
          </div>
          <div class="modal_text_md text-center">{{ title }}</div>
        </div>
        <br>
          <div style="object-fit: contain;">
            <img class="img-fluid" style="width: 839px; height: 480px;" src="assets/img/applied-load-guide/desktop_new.jpg">
          </div>
          <br>
          </div>
        </div>
      }
      @if (visible && isMobileView && !isDesktop && !isTablet) {
        <div class="modal_customer">
          <div class="modal_customer_body_mobile">
            <br>
              <div class="col-md-6">
                <div class="row">
                  <div class="modal_customer_close_mobile" (click)="confirm()">
                    Close
                  </div>
                  <div class="modal_text_md">{{ title }}</div>
                </div>
              </div>
              <br>
                <div class="content_mobile">
                  <ngbd-carousel-basic>
                  </ngbd-carousel-basic>
                </div>
              </div>
            </div>
          }